export default "__VITE_ASSET__DacNJxUh__"